import React from "react";
import PropertyListing from "../components/PropertyListing";
import Seo from "../components/Seo";

const Lettings = () => (
  <>
    <Seo
      title="Property to Rent in Bath & Bristol"
      description="Discover flats and houses to rent in Bath and Bristol with Anadear Estates. Fully managed, compliant lettings and a dedicated tenant team."
      path="/lettings"
    />
    <PropertyListing
      status="to-rent"
      title="Properties to Rent"
      subtitle="Lettings in Bath & Bristol"
      heroImage="https://images.unsplash.com/photo-1706606992658-b7225196f1af"
    />
  </>
);

export default Lettings;
